import React from 'react';
import './IconScroll.css';

const LOGOS = [
  { src: '/assets/Zapier.svg', alt: 'Zapier logo', title: 'Zapier automatiseringar' },
  { src: '/assets/Midjourney.svg', alt: 'Midjourney logo', title: 'Skapa bilder med Midjourney' },
  { src: '/assets/Myflow.svg', alt: 'Myflow logo', title: 'Myflow automatiseringar' },
  { src: '/assets/Make.svg', alt: 'Make logo', title: 'Make automatiseringar' },
  { src: '/assets/OpenAI.svg', alt: 'OpenAI logo', title: 'Hjälp med OpenAI API' },
];

const WorkWithLogos = () => {
    return (
        <div className="partner-container">
            Produkter vi arbetar med: 
            <div className="tscroll">
                {LOGOS.map(({ src, alt, title }) => (
                  <img key={src} src={src} alt={alt} title={title} />
                ))}
            </div>
        </div>
    );
};

export default WorkWithLogos;
